import { VendorUserType } from "auth/VendorAuth/vendorUserSlice";
import { Link } from "react-router-dom";
import { Attachment } from "../types/RfiTypes";

interface IRfiVendorAllProps {
  user?: VendorUserType;
  attachments: Attachment[];
}

const RfiReadOnlyAttachments = (props: IRfiVendorAllProps) => {
  //const rfi = useAppSelector(selectRfi);
  let questionNumber: number = 0;

  return (
    <div className="rfi-content">
      {props.attachments && (
        <ul>
          {props.attachments.map((attachment: Attachment, i: number) => {
            if (!attachment.attachmentLink) {
              return (
                <li key={attachment.id}>
                  {attachment.title
                    ? `${attachment.title} (${attachment.filename})`
                    : `${attachment.filename}`}
                </li>
              );
            }
            return (
              <li key={attachment.id}>
                {attachment.title ? `${attachment.title} (` : ""}
                <Link
                  to={`/api/v1/rfi/${attachment.rfiId}/Attachments/${attachment.attachmentLink}`}
                  target="_blank"
                  download
                >
                  {attachment.filename}
                </Link>
                {attachment.title ? `)` : ""}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default RfiReadOnlyAttachments;
